import { EPropertyType, ICoordinates } from '../../../types-library/src'

export const CDMX_PROPERTIES = {
  id: '09',
  alias: 'cdmx',
  lng: -99.1394,
  lat: 19.2769,
}

export const getQuickLinkState = (
  searchAddress?: string,
  coords?: ICoordinates
) => {
  let quickLinkState
  if (coords) {
    if (
      coords?.latitude === CDMX_PROPERTIES.lat &&
      coords?.longitude === CDMX_PROPERTIES.lng
    ) {
      return 'cdmx'
    }
  }
  if (searchAddress) {
    quickLinkState =
      isInsideCDMXfromSearchString(searchAddress) === true ? 'cdmx' : undefined
  }
  return quickLinkState
}

export const isInsideCDMXfromSearchString = (searchString: string) => {
  return String(searchString).toUpperCase().includes('CDMX')
}

export const getMinDiscountValue = (priceDiff: {
  min: number
  max: number
}) => {
  if (priceDiff.max && priceDiff.min === 0) {
    return 0
  }

  if (priceDiff.min === 0) {
    return undefined
  }
  return priceDiff.min
}

export const getMinPriceM2 = (min: number, max: number) => {
  if (max && !min) {
    return 1
  }

  if (min) {
    return min
  }
  return undefined
}

export const getValueOrUndefinedIfIs0 = (value: number) => {
  if (!value) {
    return undefined
  }

  return value
}

export const MIN_DEFAULT_FOR_RENT = 8000
export const MIN_DEFAULT_FOR_SALE = 1000000
export const MAX_DEFAULT_FOR_RENT = 130000
export const MAX_DEFAULT_FOR_SALE = 40000000

export const returnPriceToValidated = (
  priceTo: number,
  priceFrom: number,
  propertyType?: EPropertyType
) => {
  if (isNaN(priceTo) || priceTo === null) {
    const maxDefault =
      propertyType === EPropertyType.SALE
        ? MAX_DEFAULT_FOR_SALE
        : MAX_DEFAULT_FOR_RENT
    const price = priceFrom > maxDefault ? priceFrom : priceTo
    return price
  } else {
    return priceTo
  }
}
